import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import { ConnectedRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ClerkProvider } from '@clerk/clerk-react'
import App from './App'
import './site.scss'
import configureStore from './store/_configureStore.ts'
import { RootState } from './store/RootState.ts'
import { ThemeProvider } from './ThemeProvider'
import { clerkPublishableKey } from './globals'


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')
const history = createBrowserHistory({ basename: baseUrl })

const store = configureStore(history, {})
const rootElement = document.getElementById('root')


const root = createRoot(rootElement)
root.render(
    <ClerkProvider
        publishableKey={clerkPublishableKey}
        afterSignOutUrl="/"
        signInForceRedirectUrl="/"
        signUpForceRedirectUrl="/"
        signInFallbackRedirectUrl="/"
        signUpFallbackRedirectUrl="/"
    >
        <Provider store={store}>
            <ThemeProvider>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </ThemeProvider>
        </Provider>
    </ClerkProvider>
)

